export default __webpack_public_path__ + "static/media/featured-item-11.c834bfcc.png";